import { render, staticRenderFns } from "./model_39.vue?vue&type=template&id=12440225&scoped=true"
import script from "./model_39.vue?vue&type=script&lang=js"
export * from "./model_39.vue?vue&type=script&lang=js"
import style0 from "./model_39.vue?vue&type=style&index=0&id=12440225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12440225",
  null
  
)

export default component.exports